export default {"src":"/_next/static/media/google-logo.c387ba00.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};